module.exports = __webpack_public_path__ + "static/media/pausePublic.d5db4c82.svg";